module.exports = __webpack_public_path__ + "img/kursy_inactive.2881c0b2.svg";